import { useContext } from 'react';
import { MsgOrModalContext } from 'src/context';

export default function useMessage() {
  const { messageApi } = useContext(MsgOrModalContext);
  return messageApi;
}
